export default __webpack_public_path__ + "static/media/tublianCertLogo.260a9d65.svg";